export default __webpack_public_path__ + "static/mental_health_crisis_support-1aba28839406145e4bc2fce4b3609465.png";